import React from 'react';

export default function Stores() {
  return (
    <div className="negozi-container">
      <h2>I nostri punti vendita</h2>
      <p>
        <strong>Brucaliffo Vape</strong>
      </p>
      <p>
        <strong className="etichetta">Indirizzo:</strong> Via Piane, 85, 66030 Santa Maria Imbaro CH,
        Italia
      </p>
      <p>
        <strong className="etichetta">Telefono:</strong> +39 371 664 5903
      </p>
      <p>
        <strong className="etichetta">Orari:</strong> Dal Lunedì al Sabato 9:00-13:00, 16:00-20:00,
        Domenica chiuso.
      </p>

      <p>
        <strong>Brucaliffo Vape 2.0</strong>
      </p>
      <p>
        <strong className="etichetta">Indirizzo:</strong> Via Per Fossacesia, 52, 66034 Lanciano CH,
        Italia
      </p>
      <p>
        <strong className="etichetta">Telefono:</strong> +39 371 664 4667
      </p>
      <p>
        <strong className="etichetta">Orari:</strong> Dal Lunedì al Sabato 9:00-13:00, 16:00-20:00,
        Domenica chiuso.
      </p>

      <p>
        <strong>Brucaliffo Vape 3.0</strong>
      </p>
      <p>
        <strong className="etichetta">Indirizzo:</strong> Via Monte Marcone, 85, 66041 Atessa CH,
        Italia
      </p>
      <p>
        <strong className="etichetta">Telefono:</strong> +39 377 383 9381
      </p>
      <p>
        <strong className="etichetta">Orari:</strong> Dal Lunedì al Venerdì orario continuato 9:00-19:30,
        Sabato 9:00-14:00, Domenica chiuso.
      </p>
    </div>
  );
}